import { createFileRoute, redirect } from '@tanstack/react-router';
import { fetchCompanyProfile } from '@/api/companies';
import { BadgesTab } from '@/app/(client)/network/-components/companyProfileTabs/badges/BadgesTab';
import { queryClient } from '@/lib/utils/queryClient';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/badges',
)({
  beforeLoad: async ({ params }) => {
    const company = await queryClient.ensureQueryData({
      queryKey: ['network', 'company', params.companyId],
      queryFn: () => fetchCompanyProfile(params.companyId),
    });
    const user = useSessionStore.getState().user;
    const isOwnCompany =
      user?.companyId === (company?.forCompanyId ?? params.companyId);
    if (!isOwnCompany) {
      throw redirect({
        to: '/network/$companyId/general-info',
        params: { companyId: params.companyId },
      });
    }
  },
  component: BadgesRoute,
});

function BadgesRoute() {
  const { companyId } = Route.useParams();
  return <BadgesTab companyId={companyId} />;
}
